import { useState, useRef, useCallback } from 'react';
import { getCurrentPosition } from '../api/locationApi';

const useLocation = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const cachedLat = useRef(null);
    const cachedLon = useRef(null);

    const getLocation = useCallback((onSuccess, onError) => {
        if (cachedLat.current && cachedLon.current) {
            onSuccess({ lat: cachedLat.current, lon: cachedLon.current });
            return;
        }

        setLoading(true);
        setError(null);
        getCurrentPosition(
            (coords) => {
                cachedLat.current = coords.latitude;
                cachedLon.current = coords.longitude;
                setLoading(false);
                onSuccess({ lat: coords.latitude, lon: coords.longitude });
            },
            () => {
                setLoading(false);
                setError("위치 정보를 가져올 수 없습니다");
                if (onError) onError();
            }
        );
    }, []);

    return { loading, error, cachedLat, cachedLon, getLocation };
};

export default useLocation;
